module.exports = __webpack_public_path__ + "static/media/app-1.c12b8544.jpg";